import type * as React from "react";

type Props = {
	nav: React.ReactNode;
	footer: React.ReactNode;
	children: React.ReactNode;
};

export function AppLayout({ nav, footer, children }: Props) {
	return (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				flexDirection: "column",
				background: "var(--surface-muted, oklch(0.97 0.01 90))",
				fontFamily: "Inter, sans-serif",
			}}
		>
			{nav}
			{children}
			<div style={{ marginTop: "auto" }}>{footer}</div>
		</div>
	);
}
